// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1tVIu","content":"styles_content__WeZzh","checkbox":"styles_checkbox__1uV_X","checkboxLabel":"styles_checkboxLabel__1tuj-"};